import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h3 className="text-2xl md:text-3xl font-bold text-foreground-950 whitespace-nowrap" style={{ fontFamily: 'var(--font-heading)' }}>
            漫画分类
          </h3>
          <p className="text-sm text-foreground-600 mt-2">按类型快速找到你喜欢的漫画</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl p-5 flex flex-col items-center text-center transition-all duration-300 hover:bg-primary-500 hover:shadow-lg"
            >
              <div className="w-14 h-14 rounded-full bg-secondary-100 flex items-center justify-center mb-3 group-hover:bg-white/20 transition-colors">
                <i className={`${cat.icon} text-2xl text-secondary-600 group-hover:text-white transition-colors`}></i>
              </div>
              <h4 className="text-sm font-semibold text-foreground-950 group-hover:text-white transition-colors whitespace-nowrap">
                {cat.name}
              </h4>
              <p className="text-xs text-foreground-500 group-hover:text-white/80 transition-colors mt-1">
                {cat.count} 部作品
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}